import * as types from './types'

import axios from 'axios'

export const loadLastPosts = ({commit}) => {
  axios.get(`${window.API_URL}/posts/last`)
    .then(({data}) => {
      commit(types.RECEIVE_LAST_POSTS, data)
    })
}



// WEBPACK FOOTER //
// ./src/app/config/store/modules/posts/actions.js